import { Maybe } from '~/utils/lib/core/prelude'
/**
 * @desc Wrapping `document.querySelector` single fetch into a `Maybe` monad
 * @example
 *      mounted() {
 *        const foo = querySelector('unknown') // Maybe.Nothing
 *        const bar = querySelector('#bar')    // Maybe.Just(<Element>)
 *
 *        // map/chain(
 *        //  doSomething
 *        // )(bar)
 *      }
 * @template {Element} T
 * @return {import('~/utils/lib/core/prelude_').Maybe<T>}
 */
export function querySelector(/** @type {string} */ querySelector) {
  const element = window.document.querySelector(querySelector)
  // @ts-ignore: compiler template limitation
  return (element instanceof Element) ?
    // @ts-ignore: compiler template limitation
    Maybe.Just(element) :
    Maybe.Nothing()
}
/**
 * @desc Derived `useQuerySelector` with second argument as `parentElement`
 * @example
 *    export default defineComponent({
 *      mounted() {
 *        const foo = querySelector2('unknown', element) // Maybe.Nothing
 *        const bar = querySelector2('#bar', element)    // Maybe.Just(<Element>)
 *
 *        // map/chain(
 *        //  doSomething
 *        // )(bar)
 *      }
 *    })
 * @template {Element} T
 * @return {import('~/utils/lib/core/prelude_').Maybe<T>}
 */
export function querySelector2(
  /** @type {string} */ querySelector,
  /** @type {Element} */ parentElement) {
  const element = parentElement.querySelector(querySelector)
  // @ts-ignore: compiler template limitation
  return (element instanceof Element) ?
    // @ts-ignore: compiler template limitation
    Maybe.Just(element) :
    Maybe.Nothing()
}
/**
 * @desc `NodeList<Element>` wrap into a simple iterable
 */
export function querySelectorAll(/** @type {string} */ querySelector) {
  return Array.from(
    window.document.querySelectorAll(querySelector)
  )
}
/**
 * @desc Derived `useQuerySelectorAll` with a secondary argument as `parentElement`
 */
export function querySelectorAll2(
  /** @type {string} */ querySelector,
  /** @type {Element} */ parentElement) {
  return Array.from(
    parentElement.querySelectorAll(querySelector)
  )
}
